"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var fontFaceUrl = "https://fonts.googleapis.com/css?family=Noto+Sans:400,700&display=swap";
var fontFamily = "'Noto Sans', Sans-Serif";
var fontSize1 = "1.2rem";
var fontSize2 = "1.4rem";
var fontSize3 = "1.6rem";
var fontSize4 = "1.8rem";
var fontSize5 = "2rem";
var fontSize6 = "2.4rem";
var fontSize7 = "3rem";
var fontSize8 = "4rem";
var fontSize9 = "7.6rem";
var fontSizeBase = "62.5%";
var fontWeightBold = 700;
var fontWeightNormal = 400;
var lineHeightCondensed = 1.3;
var lineHeightNormal = 1.5;
exports.default = {
  fontFaceUrl: fontFaceUrl,
  fontFamily: fontFamily,
  fontSize1: fontSize1,
  fontSize2: fontSize2,
  fontSize3: fontSize3,
  fontSize4: fontSize4,
  fontSize5: fontSize5,
  fontSize6: fontSize6,
  fontSize7: fontSize7,
  fontSize8: fontSize8,
  fontSize9: fontSize9,
  fontSizeBase: fontSizeBase,
  fontWeightBold: fontWeightBold,
  fontWeightNormal: fontWeightNormal,
  lineHeightCondensed: lineHeightCondensed,
  lineHeightNormal: lineHeightNormal
};